<template>
  <div id="main" ref="main">
    <template v-if="selectedXAttribute != null">
      <svg :width="width" :height="height" ref="svg">
        <g id="map" ref="map">
          <path v-for="item in mapData" :key="item.properties.BU_CODE"
            :d="geoPath(item)"
            :fill="getColor(item)"
            @mouseover="hoverIn(item)"
            @mouseleave="hoverOut"
            :class="{ selected: item.properties.BU_CODE == idSelectedCounty }"
            :ref="item.properties.BU_CODE">
          </path>
        </g>
        <g id="colorScale" :transform="'translate(' + colorScaleMargin + ',' + mapHeight + ')'">
          <text class="label"
            :x="colorScaleWidth"
            y="10"
            text-anchor="end">
            {{ selectedXAttribute.label[currentLanguage] }}
          </text>
          <rect v-for="n in colorScaleNrBlocks" :key="n"
            :x="(n-1)*(colorScaleWidth/colorScaleNrBlocks)"
            y = 20
            :width="colorScaleWidth/colorScaleNrBlocks"
            height="5"
            :fill="colorFunction(n / colorScaleNrBlocks)"
          >
          </rect>
          <g id="labels"
            :transform="'translate(0,40)'">
            <text class="axisLabel"
              :transform="'translate(0, 0)'"
              text-anchor="start"
            >
              0
            </text>
            <text class="axisLabel"
              :transform="'translate(' + colorScaleWidth + ', 0)'"
              text-anchor="end"
            >
              {{ maxValueColorAttribute }}
            </text>
          </g>
        </g>
      </svg>
    </template>
  </div>
</template>

<style scoped>
  #main {
    height: 100%;
    margin: 10px;
  }
  path {
    stroke-width: 0.5px;
    stroke: #ffffff;
  }
  path.selected {
    stroke-width: 3px;
    stroke: #ff984a;
  }
  .label {
    font-size: 9pt;
  }
  .axisLabel {
    font-size: 8pt;

  }
</style>


<script>
  import * as Topojson from 'topojson';
  import * as D3 from 'd3';

  export default {
    data() {
      return {
        width: 0,
        height: 0,
        mapWidth: 0,
        mapHeight: 0,
        colorScaleWidth: 0,
        colorScaleHeight: 40,
        colorScaleMargin: 10,
        colorScaleNrBlocks: 50,
        colorFunction: D3.interpolateViridis
      }
    },
    mounted() {
      this.width = this.$refs.main.clientWidth;
      this.height = this.$refs.main.clientHeight;
      this.mapWidth = this.width;
      this.mapHeight = this.height - this.colorScaleHeight;
      this.colorScaleWidth = this.width - 2 * this.colorScaleMargin;
    },
    computed: {
      geo() {
        return this.$store.getters.geo;
      },
      mapData() {
        return this.geo == null ? [] : Topojson.feature(this.geo, this.geo.objects.name).features;
      },
      boundingBox() {
        return this.geo == null ? [] : this.geo.bbox;
      },
      data() {
        return this.$store.getters.data;
      },
      center() {
        return this.boundingBox.length != 4 ? [] : [(this.boundingBox[0] + this.boundingBox[2]) / 2, (this.boundingBox[1] + this.boundingBox[3]) / 2];
      },
      projection() {
        let scale = 1000; //initial scale
        const proj = D3.geoMercator()
          .scale(scale)
          .translate([this.mapWidth/2, this.mapHeight/2])
          .center(this.center);
        const bboxProjLowerLeft = proj([this.boundingBox[0],this.boundingBox[1]]);
        const bboxProjUpperRight = proj([this.boundingBox[2],this.boundingBox[3]]);
        const projWidth = bboxProjUpperRight[0] - bboxProjLowerLeft[0];
        const projHeight = bboxProjLowerLeft[1] - bboxProjUpperRight[1];
        const factor = Math.min(this.mapWidth/projWidth, this.mapHeight/projHeight);
        scale *= factor;
        proj.scale(scale);
        return proj;
      },
      currentLanguage() {
        return this.$store.getters.currentLanguage;
      },
      selectedXAttribute() {
        return this.$store.getters.selectedXAttribute;
      },
      maxValueColorAttribute() {
        return D3.max(this.data, (d) => +d[this.selectedXAttribute.id]);
      },
      idSelectedCounty() {
        return this.$store.getters.idSelectedCounty;
      },
      colorScaleValueStep() {
        return this.maxValueColorAttribute / this.colorScaleNrBlocks;
      }
    },
    watch: {
      idSelectedCounty() {
        //bring svg element of selected item to front
        if (this.idSelectedCounty != null) {
          //somehow ref is array with one element: the path
          this.$refs.map.appendChild(this.$refs[this.idSelectedCounty][0]);
        }
      }

    },
    methods: {
      geoPath(d) {
        return D3.geoPath().projection(this.projection)(d);
      },
      getColor(item) {
        //find item in data
        const county = this.data.find(d => d.BU_CODE == item.properties.BU_CODE);
        if (county == null) return '#aaaaaa';
        let value = +county[this.selectedXAttribute.id];
        if (value < 0) return '#aaaaaa';
        return this.colorFunction(value/this.maxValueColorAttribute);
      },
      hoverIn(item) {
        this.$store.commit("SET_ID_SELECTED_COUNTY", item.properties.BU_CODE);
      },
      hoverOut() {
        this.$store.commit("SET_ID_SELECTED_COUNTY", null);
      }
    }
  }
</script>
